<template>
    <div class="toast-container position-fixed top-0 end-0 p-3" style="z-index: 1060">
            <transition-group name="slide-fade">
                <div v-for="alert in alerts" :key="alert.id"
                    class="toast show align-items-center border-0 shadow-lg mb-2"
                    :class="'bg-' + alert.type + '-subtle text-' + alert.type" role="alert">
                    <div class="d-flex p-3">
                        <i :class="alert.icon" class="me-3 fs-5"></i>
                        <div class="toast-body p-0 fw-medium">
                            {{ alert.message }}
                        </div>
                        <button type="button" class="btn-close ms-auto" @click="removeAlert(alert.id)"></button>
                    </div>
                </div>
            </transition-group>
        </div>
    <div class="modal fade" id="modalTransaction" tabindex="-1" aria-hidden="true" data-bs-backdrop="static"
        data-bs-keyboard="false">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content border-0 shadow-lg rounded-4">
                <div class="modal-header border-0 pt-4 px-4">
                    <h5 class="fw-bold m-0">{{ isEditing ? 'Editar Lançamento' : 'Novo Lançamento Financeiro' }}
                    </h5>
                    <button type="button" class="btn-close" @click="closeModal"></button>
                </div>

                <div class="modal-body px-4">
                    <div class="row g-3">

                        <div v-if="isEditing && (form.amount_paid > 0 || form.allows_early_payment_reward || form.payment_url)"
                            class="col-12 mb-2">
                            <div
                                class="alert alert-info border-0 shadow-sm rounded-3 p-3 mb-1 d-flex align-items-center justify-content-between">
                                <div class="d-flex align-items-center gap-2">
                                    <i class="bi bi-pie-chart-fill fs-4 text-primary"></i>
                                    <div>
                                        <h6 class="fw-bold mb-0 text-dark">Valores da cobrança</h6>
                                        <span class="small text-muted">
                                            Total: R$ {{ formatCurrency(form.amount) }} |
                                            Confirmado: <strong class="text-success">R$ {{
                                                formatCurrency(form.amount_paid || 0) }}</strong> |
                                            Saldo Restante: <strong class="text-danger">R$ {{
                                                formatCurrency(Math.max(0, form.amount - (form.amount_paid || 0)))
                                            }}</strong>
                                        </span>
                                    </div>
                                </div>
                                <span class="badge bg-primary px-2 py-1" v-if="form.payment_url != ''">Checkout
                                    Ativo</span>
                            </div>
                        </div>

                        <div class="col-12 mb-2 d-flex justify-content-center">
                            <div class="btn-group" role="group">
                                <input type="radio" class="btn-check" name="btnradio" id="btnradio1" autocomplete="off"
                                    value="in" v-model="form.type" :disabled="isEditing" @click="typeTransaction('in')">
                                <label class="btn btn-outline-success px-4 fw-bold" for="btnradio1"><i
                                        class="bi bi-arrow-down-left me-1"></i> Receita</label>

                                <input type="radio" class="btn-check" name="btnradio" id="btnradio2" autocomplete="off"
                                    value="out" v-model="form.type" :disabled="isEditing"
                                    @click="typeTransaction('out')">
                                <label class="btn btn-outline-danger px-4 fw-bold" for="btnradio2"><i
                                        class="bi bi-arrow-up-right me-1"></i> Despesa</label>
                            </div>
                        </div>

                        <div class="col-md-8">
                            <label class="form-label small fw-bold text-muted">Descrição do Lançamento <span
                                    class="required">*</span></label>
                            <input v-model="form.description" type="text" class="form-control form-control-pmg"
                                placeholder="Ex: Pagamento de Aluguel">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Valor (R$)<span
                                    class="required">*</span></label>
                            <input type="text" class="form-control form-control-pmg text-end" placeholder="0,00"
                                :value="formatCurrencyInput(form.amount)"
                                @input="handleCurrencyInput($event, 'amount')">
                        </div>

                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Tipo de Contato</label>
                            <select v-model="form.transactionable_type" class="form-select form-control-pmg"
                                @change="contactSearchQuery = ''; form.transactionable_id = ''">
                                <option value="App\Models\Client" v-if="form.type == 'in'">Cliente</option>
                                <option value="App\Models\Supplier" v-else>Fornecedor</option>
                            </select>
                        </div>
                        <div class="col-md-8 position-relative">
                            <label class="form-label small fw-bold text-muted">Buscar Contato<span
                                    class="required">*</span></label>
                            <div class="position-relative">
                                <i
                                    class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                                <input type="text" v-model="contactSearchQuery" @input="onContactInput"
                                    @focus="showContactDropdown = true" @blur="hideContactDropdown"
                                    class="form-control form-control-pmg ps-5" placeholder="Digite o nome...">
                            </div>
                            <div v-if="showContactDropdown && contactSearchResults.length > 0"
                                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                                style="z-index: 1060;">
                                <ul class="list-unstyled mb-0">
                                    <li v-for="contact in contactSearchResults" :key="contact.id"
                                        @mousedown="selectContact(contact)"
                                        class="p-3 autocomplete-item border-bottom cursor-pointer">
                                        <div class="fw-bold text-dark">{{ contact.name }}</div>
                                        <div class="small text-muted">{{ contact.document || 'Sem Documento' }}
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Data de Competência<span
                                    class="required">*</span></label>
                            <input v-model="form.competence_date" type="date" class="form-control form-control-pmg">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Data de Vencimento<span
                                    class="required">*</span></label>
                            <input v-model="form.due_date" type="date" class="form-control form-control-pmg">
                        </div>
                        <div class="col-md-4">
                            <label class="form-label small fw-bold text-muted">Data de Pagamento</label>
                            <input v-model="form.payment_date" type="date" class="form-control form-control-pmg"
                                :disabled="form.status !== 'paid'">
                        </div>

                        <div class="col-12 mt-4">
                            <h6 class="fw-bold border-bottom pb-2">Informações de Pagamento</h6>
                        </div>

                        <div class="col-md-6 position-relative">
                            <label class="form-label small fw-bold text-muted">Categoria<span
                                    class="required">*</span></label>
                            <div class="position-relative">
                                <i
                                    class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                                <input type="text" v-model="categorySearchQuery" @focus="showCategoryDropdown = true"
                                    @blur="hideCategoryDropdown" class="form-control form-control-pmg ps-5"
                                    placeholder="Buscar categoria...">
                            </div>
                            <div v-if="showCategoryDropdown && filteredCategories.length > 0"
                                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                                style="z-index: 1060;">
                                <ul class="list-unstyled mb-0">
                                    <li v-for="cat in filteredCategories" :key="cat.id" @mousedown="selectCategory(cat)"
                                        class="p-3 autocomplete-item border-bottom cursor-pointer">
                                        <div class="fw-bold text-dark">{{ cat.name }}</div>
                                    </li>
                                </ul>
                            </div>
                            <div v-if="showCategoryDropdown && filteredCategories.length === 0"
                                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1 p-3 text-center text-muted"
                                style="z-index: 1060;">
                                Nenhuma categoria encontrada.
                            </div>
                        </div>
                        <div class="col-md-6 position-relative">
                            <label class="form-label small fw-bold text-muted">Centro de Custo</label>
                            <div class="position-relative">
                                <i
                                    class="bi bi-search position-absolute top-50 start-0 translate-middle-y ms-3 text-muted"></i>
                                <input type="text" v-model="costCenterSearchQuery"
                                    @focus="showCostCenterDropdown = true" @blur="hideCostCenterDropdown"
                                    class="form-control form-control-pmg ps-5" placeholder="Buscar centro de custo...">
                            </div>

                            <div v-if="showCostCenterDropdown && filteredCostCenters.length > 0"
                                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1"
                                style="z-index: 1060;">
                                <ul class="list-unstyled mb-0">
                                    <li v-for="cc in filteredCostCenters" :key="cc.id" @mousedown="selectCostCenter(cc)"
                                        class="p-3 autocomplete-item border-bottom cursor-pointer">
                                        <div class="fw-bold text-dark">
                                            <span v-if="cc.code" class="text-secondary fw-medium me-1">[{{ cc.code
                                            }}]</span>
                                            {{ cc.name }}
                                        </div>
                                    </li>
                                </ul>
                            </div>

                            <div v-if="showCostCenterDropdown && filteredCostCenters.length === 0"
                                class="autocomplete-dropdown shadow-lg rounded-3 border bg-white position-absolute w-100 mt-1 p-3 text-center text-muted"
                                style="z-index: 1060;">
                                Nenhum centro de custo encontrado.
                            </div>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Forma de Pagamento</label>
                            <select v-model="form.payment_method" class="form-select form-control-pmg">
                                <option value="pix">PIX</option>
                                <option value="boleto">Boleto</option>
                                <option value="credit_card">Cartão de Crédito</option>
                                <option value="bank_transfer">Transferência</option>
                                <option value="cash">Dinheiro</option>
                                <option value="checkout">Link de Pagamento (Cliente Escolhe)</option>
                            </select>
                        </div>
                        <div class="col-md-6">
                            <label class="form-label small fw-bold text-muted">Status</label>
                            <select v-model="form.status" class="form-select form-control-pmg"
                                @change="handleStatusChange">
                                <option value="pending">Pendente</option>
                                <option value="paid">Pago</option>
                                <option value="partial">Parcial</option>
                                <option value="overdue">Atrasado</option>
                                <option value="canceled">Cancelado</option>
                            </select>
                        </div>
                        <transition name="fade">
                            <div v-if="form.type === 'in'" class="col-12 mt-3">
                                <div class="p-3 border rounded-3 shadow-sm"
                                    style="background-color: #f0fdf4; border: 1px dashed #bbf7d0 !important;">

                                    <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                                        <input class="form-check-input bg-success border-success" type="checkbox"
                                            role="switch" id="productsSwitch" v-model="hasProducts"
                                            style="transform: scale(1.2); cursor: pointer;">
                                        <label class="form-check-label fw-bold text-dark ms-2" for="productsSwitch">
                                            <i class="bi bi-box-seam text-success me-1"></i> Vincular produtos a
                                            esta receita?
                                        </label>
                                    </div>

                                    <transition name="fade">
                                        <div v-if="hasProducts" class="mt-3 pt-3 border-top border-success-subtle">

                                            <div
                                                class="row mb-3 bg-light p-3 rounded-3 border border-secondary-subtle mx-0">
                                                <div class="col-md-6 col-12">
                                                    <label class="form-label small fw-bold text-dark mb-1">
                                                        <i class="bi bi-shop me-1"></i> Filial de Origem do Estoque
                                                        <span class="text-danger">*</span>
                                                    </label>
                                                    <select v-model="form.product_branch_id"
                                                        @change="handleProductBranchChange(false)" class="form-select">
                                                        class="form-select shadow-sm" required>
                                                        <option :value="null" disabled>Selecione a filial
                                                            primeiro...</option>
                                                        <option v-for="branch in branches" :key="branch.id"
                                                            :value="branch.id">
                                                            {{ branch.name || branch.trading_name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-md-6 col-12 d-flex align-items-center mt-3 mt-md-0">
                                                    <div class="small text-muted">
                                                        <i class="bi bi-info-circle text-primary me-1"></i>
                                                        Os produtos disponíveis e seus estoques dependem da filial
                                                        selecionada.
                                                    </div>
                                                </div>
                                            </div>

                                            <div v-for="(item, index) in form.products" :key="'prod-' + index"
                                                class="row g-2 mb-4 align-items-end">

                                                <div class="col-md-4 col-12 position-relative">
                                                    <label
                                                        class="form-label small fw-bold text-muted mb-1">Produto</label>
                                                    <div class="input-group shadow-sm">
                                                        <span class="input-group-text bg-white border-end-0 px-2"
                                                            :class="!form.product_branch_id ? 'text-warning' : 'text-muted'">
                                                            <i class="bi"
                                                                :class="!form.product_branch_id ? 'bi-lock-fill' : 'bi-search'"
                                                                style="font-size: 0.85rem;"></i>
                                                        </span>
                                                        <input type="text"
                                                            class="form-control form-control-pmg border-start-0 ps-0"
                                                            :class="{ 'bg-light': !form.product_branch_id, 'bg-white': form.product_branch_id, 'border-danger': !item.id && item.searchQuery }"
                                                            v-model="item.searchQuery"
                                                            :placeholder="form.product_branch_id ? 'Buscar produto...' : 'Selecione a filial acima'"
                                                            :disabled="!form.product_branch_id"
                                                            @focus="item.showDropdown = true" @blur="hideDropdown(item)"
                                                            @input="handleSearchInput(item)">
                                                    </div>

                                                    <ul v-if="item.showDropdown && form.product_branch_id"
                                                        class="dropdown-menu show w-100 shadow-lg border-0 p-0 rounded-3 overflow-hidden position-absolute"
                                                        style="max-height: 250px; overflow-y: auto; top: 100%; z-index: 1080; margin-top: 4px;">
                                                        <li v-if="filteredList(item.searchQuery, availableProducts).length === 0"
                                                            class="p-3 text-muted small text-center">
                                                            Nenhum produto encontrado.
                                                        </li>
                                                        <li v-for="p in filteredList(item.searchQuery, availableProducts)"
                                                            :key="p.id">
                                                            <a class="dropdown-item cursor-pointer py-2 border-bottom"
                                                                @mousedown.prevent="selectAutocompleteItem(item, p, 'product')">
                                                                <div
                                                                    class="d-flex justify-content-between align-items-start">
                                                                    <div class="fw-bold text-dark text-truncate"
                                                                        style="font-size: 0.85rem; max-width: 70%;">
                                                                        {{ p.name }}
                                                                    </div>
                                                                    <span class="badge"
                                                                        :class="p.stock > 0 ? 'bg-primary-subtle text-primary border' : 'bg-danger-subtle text-danger border'">
                                                                        Estoque: {{ p.stock || 0 }}
                                                                    </span>
                                                                </div>
                                                                <div class="text-success small fw-bold mt-1">R$ {{
                                                                    formatCurrencyInput(p.price || p.value) }}</div>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="col-md-2 col-3 position-relative">
                                                    <label class="form-label small fw-bold text-muted mb-1">Qtd</label>
                                                    <input type="number"
                                                        class="form-control form-control-pmg bg-white text-center"
                                                        :class="{ 'border-danger text-danger fw-bold': item.id && item.quantity > (item.stock || 0) }"
                                                        v-model.number="item.quantity" min="1" :disabled="!item.id"
                                                        @input="autoCalculateTotal">

                                                    <div v-if="item.id" class="position-absolute w-100 text-center mt-1"
                                                        style="font-size: 0.7rem; left: 0; top: 100%;">
                                                        <span
                                                            :class="item.quantity > (item.stock || 0) ? 'text-danger fw-bold' : 'text-muted'">
                                                            Max: {{ item.stock || 0 }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-md-3 col-4">
                                                    <label class="form-label small fw-bold text-muted mb-1">Unit.
                                                        (R$)</label>
                                                    <input type="text"
                                                        class="form-control form-control-pmg bg-white text-end"
                                                        :value="formatCurrencyInput(item.unit_price)"
                                                        @input="handleItemCurrencyInput($event, item)"
                                                        :disabled="!item.id" placeholder="0,00">
                                                </div>

                                                <div class="col-md-2 col-3">
                                                    <label
                                                        class="form-label small fw-bold text-success mb-1">Subtotal</label>
                                                    <input type="text"
                                                        class="form-control form-control-pmg text-end fw-bold"
                                                        style="background-color: #dcfce7; border-color: #bbf7d0; color: #166534;"
                                                        :value="formatCurrencyInput((item.quantity || 0) * (item.unit_price || 0))"
                                                        readonly tabindex="-1">
                                                </div>

                                                <div class="col-md-1 col-2 text-end">
                                                    <button class="btn w-100 py-2 rounded-3"
                                                        :class="(form.products.length === 1 && !item.id) ? 'btn-light text-muted' : 'btn-outline-danger'"
                                                        :disabled="form.products.length === 1 && !item.id" tabindex="-1"
                                                        @click.prevent="removeItem(index, 'products')">
                                                        <i class="bi bi-trash3"></i>
                                                    </button>
                                                </div>

                                            </div>

                                            <button
                                                class="btn btn-sm btn-outline-success fw-bold mt-2 rounded-pill shadow-sm"
                                                @click.prevent="addItem('products')" 
                                                :disabled="!form.product_branch_id">
                                                <i class="bi bi-plus-lg me-1"></i> Adicionar Linha de Produto
                                            </button>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </transition>

                        <transition name="fade">
                            <div v-if="form.type === 'in'" class="col-12 mt-3">
                                <div class="p-3 border rounded-3 shadow-sm"
                                    style="background-color: #f5f3ff; border: 1px dashed #ddd6fe !important;">

                                    <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            id="servicesSwitch" v-model="hasServices"
                                            style="background-color: #8b5cf6; border-color: #8b5cf6; transform: scale(1.2); cursor: pointer;">
                                        <label class="form-check-label fw-bold text-dark ms-2" for="servicesSwitch">
                                            <i class="bi bi-tools me-1" style="color: #8b5cf6;"></i> Vincular
                                            serviços a esta receita?
                                        </label>
                                    </div>
                                    <transition name="fade">
                                        <div v-if="hasServices" class="mt-3 pt-3 border-top"
                                            style="border-color: #e2e8f0 !important;">

                                            <!-- NOVO: Seletor de Filial Exclusivo para Serviços -->
                                            <div
                                                class="row mb-3 bg-light p-3 rounded-3 border border-secondary-subtle mx-0">
                                                <div class="col-md-6 col-12">
                                                    <label class="form-label small fw-bold text-dark mb-1">
                                                        <i class="bi bi-shop me-1" style="color: #8b5cf6;"></i> Filial
                                                        Prestadora do Serviço
                                                        <span class="text-danger">*</span>
                                                    </label>
                                                    <select v-model="form.service_branch_id"
                                                        @change="handleServiceBranchChange(false)"
                                                        class="form-select shadow-sm" required>
                                                        <option :value="null" disabled>Selecione a filial primeiro...
                                                        </option>
                                                        <option v-for="branch in branches"
                                                            :key="'serv-branch-' + branch.id" :value="branch.id">
                                                            {{ branch.name || branch.trading_name }}
                                                        </option>
                                                    </select>
                                                </div>
                                                <div class="col-md-6 col-12 d-flex align-items-center mt-3 mt-md-0">
                                                    <div class="small text-muted">
                                                        <i class="bi bi-info-circle text-primary me-1"></i>
                                                        Os serviços disponíveis dependem da filial selecionada.
                                                    </div>
                                                </div>
                                            </div>

                                            <!-- Lista de Serviços -->
                                            <div v-for="(item, index) in form.services" :key="'serv-' + index"
                                                class="row g-2 mb-2 align-items-end">

                                                <div class="col-md-4 col-12 position-relative">
                                                    <label class="form-label small fw-bold text-muted mb-1">Serviço
                                                        Prestado</label>
                                                    <div class="input-group shadow-sm">
                                                        <span class="input-group-text bg-white border-end-0 px-2"
                                                            :class="!form.service_branch_id ? 'text-warning' : 'text-muted'">
                                                            <i class="bi"
                                                                :class="!form.service_branch_id ? 'bi-lock-fill' : 'bi-search'"
                                                                style="font-size: 0.85rem;"></i>
                                                        </span>
                                                        <input type="text"
                                                            class="form-control form-control-pmg border-start-0 ps-0"
                                                            :class="{ 'bg-light': !form.service_branch_id, 'bg-white': form.service_branch_id, 'border-danger': !item.id && item.searchQuery }"
                                                            v-model="item.searchQuery"
                                                            :placeholder="form.service_branch_id ? 'Buscar serviço...' : 'Selecione a filial acima'"
                                                            :disabled="!form.service_branch_id"
                                                            @focus="item.showDropdown = true" @blur="hideDropdown(item)"
                                                            @input="handleSearchInput(item)">
                                                    </div>

                                                    <ul v-if="item.showDropdown && form.service_branch_id"
                                                        class="dropdown-menu show w-100 shadow-lg border-0 p-0 rounded-3 overflow-hidden position-absolute"
                                                        style="max-height: 250px; overflow-y: auto; top: 100%; z-index: 1080; margin-top: 4px;">
                                                        <li v-if="filteredList(item.searchQuery, availableServices).length === 0"
                                                            class="p-3 text-muted small text-center">
                                                            Nenhum serviço encontrado.
                                                        </li>
                                                        <li v-for="s in filteredList(item.searchQuery, availableServices)"
                                                            :key="s.id">
                                                            <a class="dropdown-item cursor-pointer py-2 border-bottom"
                                                                @mousedown.prevent="selectAutocompleteItem(item, s, 'service')">
                                                                <div
                                                                    class="d-flex justify-content-between align-items-start">
                                                                    <div class="fw-bold text-dark text-truncate"
                                                                        style="font-size: 0.85rem; max-width: 70%;">
                                                                        {{ s.name || s.description || s.title ||
                                                                            'Serviço sem nome' }}
                                                                    </div>
                                                                    <span
                                                                        class="badge bg-purple-subtle text-purple border"
                                                                        style="background-color: #f5f3ff; color: #8b5cf6; border-color: #ddd6fe;">
                                                                        Disp: {{ s.stock || 0 }}
                                                                    </span>
                                                                </div>
                                                                <div class="small fw-bold mt-1"
                                                                    style="color: #8b5cf6 !important;">
                                                                    R$ {{ formatCurrencyInput(s.sale_price || s.price ||
                                                                        s.value) }}
                                                                </div>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>

                                                <div class="col-md-2 col-3 position-relative">
                                                    <label class="form-label small fw-bold text-muted mb-1">Qtd</label>
                                                    <input type="number"
                                                        class="form-control form-control-pmg bg-white text-center"
                                                        :class="{ 'border-danger text-danger fw-bold': item.id && item.quantity > (item.stock || 0) }"
                                                        v-model.number="item.quantity" min="1" :disabled="!item.id"
                                                        @input="autoCalculateTotal">

                                                    <div v-if="item.id" class="position-absolute w-100 text-center mt-1"
                                                        style="font-size: 0.7rem; left: 0; top: 100%;">
                                                        <span
                                                            :class="item.quantity > (item.stock || 0) ? 'text-danger fw-bold' : 'text-muted'">
                                                            Max: {{ item.stock || 0 }}
                                                        </span>
                                                    </div>
                                                </div>

                                                <div class="col-md-3 col-4">
                                                    <label class="form-label small fw-bold text-muted mb-1">Unit.
                                                        (R$)</label>
                                                    <input type="text"
                                                        class="form-control form-control-pmg bg-white text-end"
                                                        :value="formatCurrencyInput(item.unit_price)"
                                                        @input="handleItemCurrencyInput($event, item)"
                                                        :disabled="!item.id" placeholder="0,00">
                                                </div>

                                                <div class="col-md-2 col-3">
                                                    <label class="form-label small fw-bold mb-1"
                                                        style="color: #6d28d9;">Subtotal</label>
                                                    <input type="text"
                                                        class="form-control form-control-pmg text-end fw-bold"
                                                        style="background-color: #ede9fe; border-color: #ddd6fe; color: #5b21b6;"
                                                        :value="formatCurrencyInput((item.quantity || 0) * (item.unit_price || 0))"
                                                        readonly tabindex="-1">
                                                </div>

                                                <div class="col-md-1 col-2 text-end">
                                                    <button class="btn w-100 py-2 rounded-3"
                                                        :class="(form.services.length === 1 && !item.id) ? 'btn-light text-muted' : 'btn-outline-danger'"
                                                        :disabled="form.services.length === 1 && !item.id" tabindex="-1"
                                                        @click.prevent="removeItem(index, 'services')">
                                                        <i class="bi bi-trash3"></i>
                                                    </button>
                                                </div>
                                            </div>

                                            <button class="btn btn-sm fw-bold mt-2 rounded-pill shadow-sm text-white"
                                                style="background-color: #8b5cf6; border: none;"
                                                @click.prevent="addItem('services')"
                                                :disabled="!form.service_branch_id">
                                                <i class="bi bi-plus-lg me-1"></i> Adicionar Serviço
                                            </button>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </transition>


                        <transition name="fade">
                            <div  v-if="form.type === 'in'" class="p-3 border rounded-3 shadow-sm"
                                style="background-color: #f0f9ff; border-color: #bae6fd !important;">

                                <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                                    <input class="form-check-input" type="checkbox" role="switch" id="genChargeSwitch"
                                        v-model="form.generate_charge" style="transform: scale(1.2); cursor: pointer;">
                                    <label class="form-check-label fw-bold text-dark ms-2" for="genChargeSwitch">
                                        <i class="bi bi-cloud-check-fill text-primary me-1"></i>
                                        Gerar cobrança automática no Gateway?
                                    </label>
                                </div>

                                <!-- Área de seleção do Gateway: Só aparece se o switch estiver ativado -->
                                <transition name="fade">
                                    <div v-if="form.generate_charge" class="mt-3 pt-3 border-top border-info-subtle">
                                        <label class="form-label small fw-bold text-muted">
                                            Conta/Gateway de Recebimento
                                        </label>

                                        <!-- Se houver mais de uma opção, exibimos o seletor -->
                                        <select v-if="availableGatewaysForMethod.length > 1"
                                            v-model="form.payment_gateway_id"
                                            class="form-select form-control-pmg bg-white">
                                            <option :value="null" disabled>Escolha por onde receber...</option>
                                            <option v-for="g in availableGatewaysForMethod" :key="g.id" :value="g.id">
                                                {{ g.name }} ({{ g.provider.toUpperCase() }})
                                            </option>
                                        </select>

                                        <!-- Se houver apenas uma opção, exibimos de forma fixa e informativa -->
                                        <div v-else-if="availableGatewaysForMethod.length === 1"
                                            class="p-2 bg-white border rounded-3 d-flex align-items-center">
                                            <i class="bi bi-shield-check text-success me-2"></i>
                                            <span class="fw-bold text-dark">
                                                {{ availableGatewaysForMethod[0].name }}
                                                <small class="text-muted fw-normal">({{
                                                    availableGatewaysForMethod[0].provider.toUpperCase() }})</small>
                                            </span>
                                        </div>

                                        <div class="form-text text-primary small mt-1">
                                            <i class="bi bi-info-circle"></i> Ao salvar, o boleto/PIX será gerado
                                            instantaneamente.
                                        </div>
                                    </div>
                                </transition>
                            </div>
                        </transition>

                        <transition name="fade">
                            <div v-if="form.type === 'in' && form.payment_method === 'checkout'" class="col-12 mt-3">
                                <div class="p-3 border rounded-3 shadow-sm"
                                    style="background-color: #f8fafc; border: 1px dashed #cbd5e1 !important;">
                                    <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                                        <input class="form-check-input" type="checkbox" role="switch"
                                            id="fractionalSwitch" v-model="form.allows_early_payment_reward"
                                            style="transform: scale(1.2); cursor: pointer;">
                                        <label class="form-check-label fw-bold text-dark ms-2" for="fractionalSwitch">
                                            <i class="bi bi-pie-chart-fill text-primary me-1"></i>
                                            Permitir Pagamento Fracionado no Checkout?
                                        </label>
                                    </div>

                                    <transition name="fade">
                                        <div v-if="form.allows_early_payment_reward" class="mt-3 pt-3 border-top">
                                            <div class="row g-3">
                                                <div class="col-md-12">
                                                    <label class="form-label small fw-bold text-muted">Valor Mínimo
                                                        da Fração (R$)</label>
                                                    <input type="text"
                                                        class="form-control form-control-pmg text-end bg-white"
                                                        placeholder="0,00"
                                                        :value="formatCurrencyInput(form.fractional_min_amount)"
                                                        @input="handleCurrencyInput($event, 'fractional_min_amount')">
                                                    <div class="form-text text-muted small mt-1">
                                                        O cliente não poderá fazer pagamentos menores que este
                                                        valor.
                                                    </div>
                                                </div>

                                                <div class="col-12 mt-4 mb-1">
                                                    <h6 class="fw-bold text-dark fs-6 d-flex align-items-center">
                                                        <i class="bi bi-trophy-fill text-warning me-2"></i>
                                                        Premiação por Antecipação
                                                        <i class="bi bi-question-circle text-muted ms-2 cursor-pointer"
                                                            data-bs-toggle="tooltip"
                                                            title="Incentive o pagamento antecipado! O cliente ganha dias extras no vencimento ou desconto no valor final, proporcional ao valor pago antes da data limite.">
                                                        </i>
                                                    </h6>
                                                    <p class="small text-muted mb-2">
                                                        Incentive o cliente a pagar frações antes do vencimento.
                                                        <button type="button"
                                                            class="btn btn-link btn-sm text-decoration-none fw-bold p-0"
                                                            @click="showRewardExplanation = !showRewardExplanation">
                                                            {{ showRewardExplanation ? 'Ocultar detalhes' : 'Entenda como funciona' }}
                                                        </button>

                                                        <transition name="fade">
                                                            <div v-if="showRewardExplanation"
                                                                class="mt-3 p-3 bg-light rounded-3 border shadow-sm">
                                                                <h6 class="fw-bold mb-3">Como funcionam as
                                                                    Premiações?</h6>
                                                                <div class="d-flex align-items-start mb-3">
                                                                    <div class="bg-warning-subtle p-2 rounded-3 me-3">
                                                                        <i class="bi bi-clock-history text-warning"></i>
                                                                    </div>
                                                                    <div>
                                                                        <p class="small text-muted mb-0">
                                                                            <strong>Extensão de Vencimento:</strong>
                                                                            Antecipou? Ganhou tempo. Quanto mais
                                                                            cedo pagar, mais dias de prazo o cliente
                                                                            ganha para quitar a dívida.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                                <div class="d-flex align-items-start">
                                                                    <div class="bg-success-subtle p-2 rounded-3 me-3">
                                                                        <i class="bi bi-tag-fill text-success"></i>
                                                                    </div>
                                                                    <div>
                                                                        <p class="small text-muted mb-0">
                                                                            <strong>Desconto no Saldo:</strong>
                                                                            Ganhe descontos reais abatidos
                                                                            diretamente no valor total toda vez que
                                                                            antecipar uma parcela.
                                                                        </p>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </transition>
                                                    </p>
                                                    <div class="modal fade" id="rewardExplanationModal" tabindex="-1">
                                                        <div class="modal-dialog modal-dialog-centered">
                                                            <div class="modal-content rounded-4 border-0 shadow">
                                                                <div class="modal-header border-0">
                                                                    <h5 class="fw-bold">Como funcionam as
                                                                        Premiações?</h5>
                                                                    <button type="button" class="btn-close"
                                                                        data-bs-dismiss="modal"></button>
                                                                </div>
                                                                <div class="modal-body">
                                                                    <div class="d-flex align-items-start mb-3">
                                                                        <div
                                                                            class="bg-warning-subtle p-2 rounded-3 me-3">
                                                                            <i
                                                                                class="bi bi-clock-history text-warning"></i>
                                                                        </div>
                                                                        <div>
                                                                            <h6 class="fw-bold mb-1">Extensão de
                                                                                Vencimento</h6>
                                                                            <p class="small text-muted">Quanto mais
                                                                                cedo o cliente pagar, mais tempo ele
                                                                                ganha de prazo para quitar o
                                                                                restante. É como "comprar tempo"
                                                                                pagando um pouco antes.</p>
                                                                        </div>
                                                                    </div>
                                                                    <div class="d-flex align-items-start">
                                                                        <div
                                                                            class="bg-success-subtle p-2 rounded-3 me-3">
                                                                            <i class="bi bi-tag-fill text-success"></i>
                                                                        </div>
                                                                        <div>
                                                                            <h6 class="fw-bold mb-1">Desconto no
                                                                                Saldo</h6>
                                                                            <p class="small text-muted">Ao antecipar
                                                                                um pagamento, o sistema calcula uma
                                                                                porcentagem de desconto sobre o que
                                                                                foi pago. Esse desconto é abatido na
                                                                                hora do valor total da dívida!</p>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="col-md-6">
                                                    <label class="form-label small fw-bold text-muted">Tipo de
                                                        Recompensa</label>
                                                    <select v-model="form.reward_type"
                                                        class="form-select form-control-pmg bg-white">
                                                        <option :value="null">Nenhuma</option>
                                                        <option value="extension">Extensão do Vencimento (+ Dias)
                                                        </option>
                                                        <option value="discount">Desconto no Saldo Final (%)
                                                        </option>
                                                    </select>
                                                </div>

                                                <transition name="fade" mode="out-in">
                                                    <div class="col-md-6" v-if="form.reward_type === 'discount'">
                                                        <label class="form-label small fw-bold text-muted">Fator de
                                                            Ganho (%)</label>
                                                        <div class="input-group shadow-sm">
                                                            <input type="number" step="0.01" min="0.01"
                                                                v-model.number="form.reward_percentage"
                                                                class="form-control border-end-0 bg-white"
                                                                placeholder="Ex: 1.5">
                                                            <span
                                                                class="input-group-text bg-white text-muted fw-bold">%</span>
                                                        </div>
                                                        <div class="form-text text-muted small mt-1"
                                                            style="font-size: 0.7rem;">
                                                            Multiplicador usado no cálculo diário do desconto.
                                                        </div>
                                                    </div>

                                                    <div class="col-md-6" v-else-if="form.reward_type === 'extension'">
                                                        <div
                                                            class="alert alert-warning border-0 bg-warning-subtle text-dark p-2 small mb-0 mt-2 mt-md-0 h-100 d-flex align-items-center rounded-3">
                                                            <i
                                                                class="bi bi-info-circle-fill me-2 text-warning fs-5"></i>
                                                            <span style="font-size: 0.75rem;">Os dias são
                                                                adicionados proporcionalmente ao valor da fração
                                                                paga. Não requer taxa manual.</span>
                                                        </div>
                                                    </div>
                                                </transition>
                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </transition>
                        <transition name="fade">
                            <div v-if="form.type === 'in'" class="col-12 mt-3">
                                <div class="p-3 border rounded-3 shadow-sm"
                                    style="background-color: #fff1f2; border: 1px dashed #fecdd3 !important;">

                                    <div class="form-check form-switch d-flex align-items-center gap-2 mb-0">
                                        <input class="form-check-input bg-danger border-danger" type="checkbox"
                                            role="switch" id="lateFeesSwitch" v-model="form.apply_late_fees"
                                            style="transform: scale(1.2); cursor: pointer;" :disabled="loadingSettings">
                                        <label class="form-check-label fw-bold text-dark ms-2" for="lateFeesSwitch">
                                            <i class="bi bi-calendar-x-fill text-danger me-1"></i>
                                            Cobrar Multa e Juros por Atraso?
                                        </label>
                                        <span v-if="loadingSettings" class="text-danger small ms-auto fw-bold">
                                            <span class="spinner-border spinner-border-sm me-1"></span> Carregando
                                            padrões...
                                        </span>
                                    </div>

                                    <transition name="fade">
                                        <div v-if="form.apply_late_fees"
                                            class="mt-3 pt-3 border-top border-danger-subtle">
                                            <div class="row g-3">

                                                <div class="col-md-3">
                                                    <label class="form-label small fw-bold text-muted">Tipo de
                                                        Multa</label>
                                                    <select v-model="form.fine_type"
                                                        class="form-select form-control-pmg bg-white"
                                                        :disabled="loadingSettings">
                                                        <option value="percentage">Percentual (%)</option>
                                                        <option value="fixed">Valor Fixo (R$)</option>
                                                    </select>
                                                </div>

                                                <div class="col-md-3">
                                                    <label class="form-label small fw-bold text-muted">Multa por
                                                        Atraso</label>
                                                    <div class="input-group shadow-sm">
                                                        <span v-if="form.fine_type === 'fixed'"
                                                            class="input-group-text bg-white text-muted fw-bold border-end-0">R$</span>

                                                        <input v-if="form.fine_type === 'percentage'" type="number"
                                                            step="0.01" min="0" v-model.number="form.fine_value"
                                                            class="form-control border-end-0 bg-white"
                                                            placeholder="Ex: 2.00" :disabled="loadingSettings">

                                                        <input v-else type="text" class="form-control bg-white text-end"
                                                            :class="{ 'border-start-0': form.fine_type === 'fixed' }"
                                                            :value="formatCurrencyInput(form.fine_value)"
                                                            @input="handleCurrencyInput($event, 'fine_value')"
                                                            placeholder="0,00" :disabled="loadingSettings">

                                                        <span v-if="form.fine_type === 'percentage'"
                                                            class="input-group-text bg-white text-muted fw-bold">%</span>
                                                    </div>
                                                    <div class="form-text text-muted small mt-1"
                                                        style="font-size: 0.7rem;">
                                                        Cobrada uma única vez.
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <label class="form-label small fw-bold text-muted">Juros ao Mês
                                                        (%)</label>
                                                    <div class="input-group shadow-sm">
                                                        <input type="number" step="0.01" min="0"
                                                            v-model.number="form.interest_percentage"
                                                            class="form-control border-end-0 bg-white"
                                                            placeholder="Ex: 1.00" :disabled="loadingSettings">
                                                        <span
                                                            class="input-group-text bg-white text-muted fw-bold">%</span>
                                                    </div>
                                                    <div class="form-text text-muted small mt-1"
                                                        style="font-size: 0.7rem;">
                                                        Pró-rata mês (Padrão: 1% a.m).
                                                    </div>
                                                </div>

                                                <div class="col-md-3">
                                                    <label class="form-label small fw-bold text-muted">Dias de
                                                        Tolerância</label>
                                                    <div class="input-group shadow-sm">
                                                        <input type="number" min="0"
                                                            v-model.number="form.tolerance_days"
                                                            class="form-control border-end-0 bg-white"
                                                            placeholder="Ex: 3" :disabled="loadingSettings">
                                                        <span
                                                            class="input-group-text bg-white text-muted fw-bold">dias</span>
                                                    </div>
                                                    <div class="form-text text-muted small mt-1"
                                                        style="font-size: 0.7rem;">
                                                        Prazo sem cobrança.
                                                    </div>
                                                </div>

                                                <div class="col-12 mt-2">
                                                    <div
                                                        class="alert alert-danger border-0 bg-danger-subtle text-danger p-2 small mb-0 d-flex align-items-center rounded-3">
                                                        <i class="bi bi-shield-lock-fill me-2 fs-5"></i>
                                                        <span style="font-size: 0.75rem;">Essas taxas serão
                                                            aplicadas automaticamente ao boleto ou PIX no dia
                                                            seguinte ao vencimento.</span>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>
                                    </transition>
                                </div>
                            </div>
                        </transition>
                        <div class="col-12" v-if="form.payment_method === 'pix' || form.payment_method === 'boleto'">
                            <label class="form-label small fw-bold text-muted">Linha Digitável / Chave PIX</label>
                            <input v-model="form.barcode_or_pix" type="text" class="form-control form-control-pmg"
                                placeholder="Cole aqui o código de barras ou PIX copia e cola">
                        </div>

                        <template v-if="!isEditing">
                            <div class="col-12 mt-4">
                                <div class="form-check form-switch d-flex align-items-center gap-2">
                                    <input class="form-check-input" type="checkbox" role="switch" id="recurringSwitch"
                                        v-model="form.is_recurring" style="transform: scale(1.3); cursor: pointer;">
                                    <label class="form-check-label fw-bold text-dark ms-2 mt-1"
                                        for="recurringSwitch">Lançamento
                                        Recorrente</label>
                                </div>
                            </div>
                            <transition name="fade">
                                <div v-if="form.is_recurring" class="col-12 p-3 mt-2 rounded-3"
                                    style="background-color: #f8fafc; border: 1px dashed #cbd5e1;">
                                    <div class="row g-3">
                                        <div class="col-md-6">
                                            <label class="form-label small fw-bold text-muted">Frequência</label>
                                            <select v-model="form.frequency"
                                                class="form-select form-control-pmg bg-white">
                                                <option value="monthly">Mensal</option>
                                                <option value="bimonthly">Bimestral</option>
                                                <option value="semiannual">Semestral</option>
                                                <option value="annual">Anual</option>
                                            </select>
                                        </div>
                                        <div class="col-md-6">
                                            <label class="form-label small fw-bold text-muted">Dia de
                                                Processamento</label>
                                            <input v-model.number="form.day_of_month" type="number" min="1" max="31"
                                                class="form-control form-control-pmg bg-white">
                                        </div>
                                    </div>
                                </div>
                            </transition>
                        </template>
                    </div>
                </div>

                <div class="modal-footer border-0 pb-4 px-4 mt-3 flex-column align-items-stretch">

                    <transition name="fade">
                        <div v-if="(hasProducts || hasServices) && form.type === 'in'"
                            class="w-100 p-3 mb-3 rounded-3 border d-flex justify-content-between align-items-center shadow-sm"
                            style="background-color: #f8fafc; border: 1px solid #e2e8f0 !important;">
                            <div>
                                <div class="text-muted small fw-bold text-uppercase mb-1">Total dos Itens</div>
                                <h5 class="fw-bold text-dark mb-2">R$ {{ formatCurrencyInput(form.amount) }}</h5>

                                <div class="form-check form-switch d-flex align-items-center gap-2 mb-0 ps-0">
                                    <input class="form-check-input m-0 cursor-pointer" type="checkbox" role="switch"
                                        id="syncTotalSwitch" v-model="updateTotalWithItems" @change="autoCalculateTotal"
                                        style="transform: scale(1.1);">
                                    <label class="form-check-label small fw-medium text-secondary cursor-pointer"
                                        for="syncTotalSwitch">
                                        Sincronizar com valor da transação
                                    </label>
                                </div>
                            </div>
                        </div>
                    </transition>

                    <div class="d-flex justify-content-end w-100">
                        <button type="button" class="btn btn-pmg-light me-2" @click="closeModal">Cancelar</button>
                        <button class="btn btn-pmg-primary px-4" :disabled="!isFormValid || loading"
                            @click="saveTransaction">
                            <span v-if="loading" class="spinner-border spinner-border-sm me-2"></span>
                            {{ isEditing ? 'Atualizar Lançamento' : 'Salvar Lançamento' }}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import api from '@/services/api';
import { transactionModalState } from '@/utils/transactionModalState';

export default {
    inject: ['globalLoading'],
    name: 'TransactionModal',
    data() {
        return {
            alerts: [],
            categories: [],
            paymentOptions: [],
            costCenters: [],
            branches: [],
            availableProducts: [],
            availableServices: [],
            form: {
                id: null, type: 'in', description: '', amount: '', category_id: '',
                transactionable_type: 'App\\Models\\Client', transactionable_id: '',
                status: 'pending', competence_date: '', due_date: '', payment_date: '',
                barcode_or_pix: '', is_recurring: false, frequency: 'monthly', day_of_month: 1,
                payment_method: '', payment_gateway_id: null, generate_charge: false,
                allows_fractional: false, fractional_min_amount: '', amount_paid: 0, cost_center_id: null,
                reward_type: null, reward_percentage: null, apply_late_fees: false, fine_type: 'fixed',
                fine_value: 2.00, interest_percentage: 1.00, tolerance_days: 0, products: [], services: []
            },

            contactSearchQuery: '',
            contactSearchResults: [],
            showContactDropdown: false,
            categorySearchQuery: '',
            showCategoryDropdown: false,
            costCenterSearchQuery: '',
            showCostCenterDropdown: false,

            isEditing: false,
            loading: false,
            loadingSettings: false,
            hasProducts: false,
            hasServices: false,
            updateTotalWithItems: true,
            itemsTotal: 0,
            showRewardExplanation: false,
            modalInstance: null,
            defaultGatewayIdFromSettings: null,
            settings: null,
            branch_id: null,
            service_branch_id: null,
        }
    },
    computed: {
        // Observa o estado global
        isOpen() { return transactionModalState.isOpen; },
        modalData() { return transactionModalState.data; },

        // Mantenha suas computeds do modal aqui
       isFormValid() {
    let valid = this.form.description && this.form.amount > 0 && this.form.due_date && this.form.category_id && this.form.transactionable_id;

    // TRAVA DE CONTROLE: Impede redefinir valor menor do que o cliente já pagou de fato
    if (this.isEditing && this.form.amount_paid > 0) {
        valid = valid && this.form.amount >= this.form.amount_paid;
    }

    // Validação extra para o fracionamento condicional
    if (this.form.allows_early_payment_reward) {
        valid = valid && this.form.fractional_min_amount > 0 && this.form.fractional_min_amount <= this.form.amount;
    }

    // --- NOVA TRAVA: Filial obrigatória para Produtos ---
    if (this.hasProducts) {
        // Exige que a filial esteja preenchida E que tenha pelo menos 1 produto selecionado
        valid = valid && this.form.product_branch_id && this.form.products.some(p => p.id);
    }

    // --- NOVA TRAVA: Filial obrigatória para Serviços ---
    if (this.hasServices) {
        // Exige que a filial esteja preenchida E que tenha pelo menos 1 serviço selecionado
        valid = valid && this.form.service_branch_id && this.form.services.some(s => s.id);
    }

    return valid;
},
        filteredCategories() {
            if (!this.categorySearchQuery) return this.categories;
            const query = this.categorySearchQuery.toLowerCase();
            return this.categories.filter(cat => cat.name.toLowerCase().includes(query));
        },
        filteredCostCenters() {
            if (!this.costCenterSearchQuery) return this.costCenters;

            const query = this.costCenterSearchQuery.toLowerCase().trim();
            return this.costCenters.filter(cc => {
                const matchName = cc.name?.toLowerCase().includes(query);
                const matchCode = cc.code?.toLowerCase().includes(query);
                return matchName || matchCode;
            });
        },
        availableGatewaysForMethod() {
            const method = this.form.payment_method;
            if (!method) return [];

            return this.paymentOptions.filter(gateway => {
                if (method === 'pix') return gateway.allows_pix;
                if (method === 'boleto') return gateway.allows_ticket;
                if (method === 'credit_card') return gateway.allows_credit_card;
                if (method === 'checkout') return gateway.allows_checkout;
                return false;
            });
        },
    },
    watch: {
        'form.payment_method'() {
            // 1. Limpa se não houver opções
            const available = this.availableGatewaysForMethod;

            if (available.length === 0) {
                this.form.generate_charge = false;
            } else if (available.length === 1) {
                this.form.payment_gateway_id = available[0].id;
            }
            this.form.generate_charge = false;
            const isDefaultCompatible = available.find(g => g.id === this.defaultGatewayIdFromSettings);

            if (isDefaultCompatible) {
                this.form.payment_gateway_id = this.defaultGatewayIdFromSettings;
            } else {
                this.form.payment_gateway_id = available[0].id;
            }
        },
        'form.generate_charge'(val) {
            if (val && this.availableGatewaysForMethod.length > 0) {
                if (this.availableGatewaysForMethod.length === 1) {
                    this.form.payment_gateway_id = this.availableGatewaysForMethod[0].id;
                }
            } else {
                this.form.payment_gateway_id = null;
            }
        },


        'form.products': {
            handler() { this.autoCalculateTotal(); },
            deep: true
        },
        'form.services': {
            handler() { this.autoCalculateTotal(); },
            deep: true
        },

        hasProducts(val) {
            if (!val) {
                this.form.products = [];
                this.autoCalculateTotal();
            } else if (this.form.products.length === 0) {
                this.addItem('products');
            }
        },
        hasServices(val) {
            if (!val) {
                this.form.services = [];
                this.autoCalculateTotal();
            } else if (this.form.services.length === 0) {
                this.addItem('services');
            }
        },
        isOpen(newVal) {
            if (newVal) {
                // O pulo do gato: Só é edição se tiver um ID real da transação!
                const isEditMode = this.modalData && this.modalData.id;

                // Se for edição, passa os dados. Se for novo, força passar null.
                this.initModal(isEditMode ? 'edit' : 'create', isEditMode ? this.modalData : null);

                if (this.modalInstance) {
                    this.modalInstance.show();
                }
            } else {
                if (this.modalInstance) {
                    this.modalInstance.hide();
                }
            }
        },
    },
    mounted() {
        const modalElement = document.getElementById('modalTransaction');
        if (modalElement) {
            this.modalInstance = new window.bootstrap.Modal(modalElement);
            modalElement.addEventListener('hidden.bs.modal', () => {
                transactionModalState.close();
            });
        }

        this.fetchCategories();
        this.fetchPaymentOptions();
        this.fetchCostCenters();
        this.fetchItemsForSale();
        this.fetchBranches();
        this.fetchDefaultSettings();
    },
    methods: {
        async fetchCategories() {
            try {
                const response = await api.get('/categories', { params: { no_paginate: true } });
                this.categories = response.data.data || response.data;
            } catch (e) {
                console.error("Erro ao carregar categorias");
            }
        },
        async fetchPaymentOptions() {
            try {
                const response = await api.get('/payment-gateways/options');
                this.paymentOptions = response.data;
            } catch (error) {
                console.error("Erro ao carregar opções de pagamento");
            }
        },
        async fetchCostCenters() {
            try {
                const response = await api.get('/cost-centers', { params: { no_paginate: true } });
                this.costCenters = response.data.data || response.data;
            } catch (e) {
                console.error("Erro ao carregar centros de custo");
            }
        },
        async fetchDefaultSettings() {
            this.loadingSettings = true;
            try {
                const response = await api.get('/system-settings/defaults');
                this.settings = response.data.data;
                this.defaultGatewayIdFromSettings = this.settings.default_gateway_id;
                // Multa e Juros
                this.form.fine_type = this.settings.fine_type || 'percentage';
                this.form.fine_value = this.settings.fine_value || 0;
                this.form.interest_percentage = this.settings.interest_percentage || 0;
                this.form.tolerance_days = this.settings.tolerance_days || 0;

                this.form.fractional_min_amount = this.settings.fractional_min_amount || 10.00;
                this.form.reward_type = this.settings.reward_type || 'extension';
                this.form.reward_percentage = this.settings.reward_percentage || 1.00;
                if (this.settings.default_gateway_id) {
                    this.form.payment_gateway_id = this.settings.default_gateway_id;
                }
            } catch (error) {
                console.error("Erro ao carregar configurações padrão:", error);
            } finally {
                this.loadingSettings = false;
            }
        },
        async fetchItemsForSale() {
            try {
                const [prodRes, servRes] = await Promise.all([
                    api.get('/products', { params: { no_paginate: true } }),
                    api.get('/services', { params: { no_paginate: true } })
                ]);
                this.availableProducts = prodRes.data.data || prodRes.data;
                this.availableServices = servRes.data.data || servRes.data;
            } catch (error) {
                console.error("Erro ao carregar produtos/serviços", error);
            }
        },
        async fetchBranches() {
            try {
                const response = await api.get('/branches');
                this.branches = response.data.data || response.data;
            } catch (error) {
                this.showAlert('Erro ao carregar filiais', 'danger');
            }
        },

        initModal(mode, item = null) {
            this.isEditing = mode === 'edit';
            this.isViewing = mode === 'show';

            if (item) {
                // 1. Clonamos os dados básicos
                this.form = { ...item };

                // Forma de Pagamento
                if (item.payment_method) {
                    this.form.payment_method = item.payment_method.toLowerCase().trim();
                }

                // 2. CORREÇÃO DAS DATAS: Cortando o timestamp (T00:00:00Z) para forçar o formato YYYY-MM-DD exigido pelo HTML
                if (item.competence_date) this.form.competence_date = item.competence_date.split('T')[0];
                if (item.due_date) this.form.due_date = item.due_date.split('T')[0];
                if (item.payment_date) this.form.payment_date = item.payment_date.split('T')[0];

                // 3. CORREÇÃO DOS AUTOCOMPLETES (Campos de Busca)
                this.contactSearchQuery = item.transactionable?.name || '';
                this.categorySearchQuery = item.category?.name || '';

                // Aqui estava o problema do Centro de Custo! Precisamos preencher a variável visual
                if (item.cost_center) {
                    this.costCenterSearchQuery = item.cost_center.code
                        ? `[${item.cost_center.code}] ${item.cost_center.name}`
                        : item.cost_center.name;
                } else {
                    this.costCenterSearchQuery = '';
                }

                // 4. GARANTIA DE BOOLEANOS (Evita o watcher desativar recursos por falsos positivos)
                this.form.allows_early_payment_reward = !!item.allows_early_payment_reward;
                this.form.apply_late_fees = !!item.apply_late_fees;
                this.form.generate_charge = !!item.generate_charge;
                this.form.is_recurring = !!item.is_recurring;

                // Força a restauração do valor fracionado mínimo para não ser limpo pelo watcher acidentalmente
                if (this.form.allows_early_payment_reward) {
                    this.form.fractional_min_amount = item.fractional_min_amount;
                }

                // Regras e Recompensas - Previne falhas se o back-end enviar aninhado na relation 'rules'
                this.form.reward_type = item.rules?.reward_type || item.reward_type || null;
                this.form.reward_percentage = item.rules?.reward_percentage || item.reward_percentage || null;

                // --- MAPEAMENTO DE PRODUTOS ---
                this.form.products = (item.products || []).map(p => ({
                    id: p.id,
                    searchQuery: p.name || p.description || p.title || '',
                    quantity: p.pivot?.quantity || p.quantity || 1,
                    unit_price: p.pivot?.unit_price || p.sale_price || p.price || 0,
                    showDropdown: false
                }));

                // --- MAPEAMENTO DE SERVIÇOS ---
                this.form.services = (item.services || []).map(s => ({
                    id: s.id,
                    searchQuery: s.name || s.description || s.title || '',
                    quantity: s.pivot?.quantity || s.quantity || 1,
                    unit_price: s.pivot?.unit_price || s.sale_price || s.price || 0,
                    showDropdown: false
                }));

                // --- FILIAL DE SERVIÇOS ---
                this.form.service_branch_id = item.service_branch_id || null;
                if (this.form.service_branch_id) {
                    this.handleServiceBranchChange(true);
                }

                // Ativa os switches se houver itens
                this.hasProducts = this.form.products.length > 0;
                this.hasServices = this.form.services.length > 0;

                // Desativa a atualização automática do valor principal ao editar
                this.updateTotalWithItems = false;

                // Força o cálculo inicial para preencher os subtotais na tela
                this.autoCalculateTotal();

            } else {
                this.resetForm();
            }

            if (this.modalInstance) {
                this.modalInstance.show();
            }
        },

        async saveTransaction() {
            this.loading = true;
            this.globalLoading.show('Processando transação...');
            try {
                await (this.isEditing
                    ? api.put(`/transactions/${this.form.id}`, this.form)
                    : api.post('/transactions', this.form));

                // AVISA O SISTEMA QUE SALVOU COM SUCESSO!
                transactionModalState.notifySuccess();
                transactionModalState.close();

            } catch (e) {
                if (e.response?.status === 422) {
                    const validationErrors = e.response.data?.data || e.response.data?.errors;
                    this.errors = validationErrors || {};
                    
                    if (!validationErrors || Object.keys(validationErrors).length === 0) {
                        this.showAlert("Erro de validação. Verifique os campos preenchidos.", "error");
                        return;
                    }
                    
                    let mensagensErro = "Os seguintes campos precisam de correção:\n\n";
                    for (const campo in validationErrors) {
                        mensagensErro += `- ${validationErrors[campo][0]}\n`;
                    }
                   
                    this.showAlert(mensagensErro, "error");
                } else {
                    console.error("Erro desconhecido:", e);
                    this.showAlert("Erro ao salvar lançamento.", "error");
                }
            } finally {
                this.loading = false;
                this.globalLoading.hide();
            }
        },
        addItem(type) {
            // Criamos um novo objeto com TODAS as propriedades rastreáveis
            const newItem = {
                id: null,
                name: '',
                quantity: 1,
                unit_price: 0,
                stock: 0,         // <--- ADICIONADO: Garante a reatividade do limite de estoque
                searchQuery: '',
                showDropdown: false
            };

            // Usamos o push normal, mas forçamos o Vue a notar a mudança
            this.form[type].push(newItem);

            // Forçamos o recálculo
            this.$nextTick(() => {
                this.autoCalculateTotal();
            });
        },
        removeItem(index, type) {
            this.form[type].splice(index, 1);
            this.$nextTick(() => {
                if (this.form[type].length === 0) {
                    this.addItem(type);
                }
                this.autoCalculateTotal();
            });
        },

        updateItemPrice(item, type) {
            const list = type === 'product' ? this.availableProducts : this.availableServices;
            const selected = list.find(x => x.id == item.id); // Use == para evitar erro de tipo (string vs number)
            if (selected) {
                // Força a leitura do sale_price que está no banco
                item.unit_price = parseFloat(selected.sale_price || selected.price || selected.value || 0);
                this.autoCalculateTotal();
            }
        },
        handleItemCurrencyInput(event, item) {
            let value = event.target.value.replace(/\D/g, "");
            if (value === "") {
                item.unit_price = 0;
                event.target.value = '';
                this.autoCalculateTotal();
                return;
            }
            let numericValue = (parseInt(value, 10) / 100);
            event.target.value = numericValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            item.unit_price = numericValue;
            this.autoCalculateTotal();
        },
        autoCalculateTotal() {
            this.$nextTick(() => {
                let total = 0;

                // Use o Number() para garantir que não vai concatenar strings
                if (this.hasProducts && Array.isArray(this.form.products)) {
                    this.form.products.forEach(p => {
                        total += (Number(p.quantity) || 0) * (Number(p.unit_price) || 0);
                    });
                }

                if (this.hasServices && Array.isArray(this.form.services)) {
                    this.form.services.forEach(s => {
                        total += (Number(s.quantity) || 0) * (Number(s.unit_price) || 0);
                    });
                }

                this.itemsTotal = total;
                if (this.updateTotalWithItems) {
                    this.form.amount = total;
                }
            });
        },

        filteredList(query, list) {
            if (!query) return list.slice(0, 50);
            const lowerQuery = query.toLowerCase();
            return list.filter(x => x.name && x.name.toLowerCase().includes(lowerQuery)).slice(0, 50);
        },

        // Ação de clique no item da lista suspensa
        selectAutocompleteItem(item, selectedResource) {
            // Atribui o ID corretamente
            item.id = selectedResource.id;

            // CORREÇÃO: Tenta buscar o nome, se não achar, busca a descrição ou título
            item.searchQuery = selectedResource.name || selectedResource.description || selectedResource.title || '';

            item.showDropdown = false;

            // BUSCA O PREÇO DIRETO DO OBJETO SELECIONADO
            const price = parseFloat(selectedResource.sale_price || selectedResource.price || selectedResource.value || 0);

            // Atribui diretamente ao item da linha
            item.unit_price = price;

            // TRANSFERE O ESTOQUE DA API PARA A LINHA DA TABELA
            item.stock = selectedResource.stock || 0;

            // Recalcula o total
            this.autoCalculateTotal();
        },
        // Se o usuário digitar algo, desvincula o ID anterior e zera o preço
        handleSearchInput(item) {
            item.id = null;
            item.unit_price = 0;
            this.autoCalculateTotal();
        },

        // Fecha a lista com um leve delay (caso contrário, o click na lista falha)
        hideDropdown(item) {
            setTimeout(() => { item.showDropdown = false; }, 200);
        },
        resetForm() {
            const today = new Date().toISOString().split('T')[0];
            this.form = {
                id: null, type: 'in', description: '', amount: '', category_id: '',
                transactionable_type: 'App\\Models\\Client',
                transactionable_id: '',
                status: 'pending', competence_date: today, due_date: today, payment_date: '',
                payment_method: 'pix',
                barcode_or_pix: '',
                cost_center_id: null,
                is_recurring: false, frequency: 'monthly', day_of_month: 1,
                generate_charge: false,
                payment_gateway_id: null,
                allows_early_payment_reward: false,
                fractional_min_amount: '',
                amount_paid: 0,
                fine_type: this.form.fine_type || 'percentage',
                fine_value: this.form.fine_value || 2.00,
                interest_percentage: this.form.interest_percentage || 1.00,
                tolerance_days: this.form.tolerance_days || 0,
                reward_type: this.form.reward_type || null
            };

            this.contactSearchQuery = '';
            this.categorySearchQuery = '';
            this.costCenterSearchQuery = '';
            this.isEditing = false;
            this.hasProducts = false;
            this.hasServices = false;
            this.form.products = [];
            this.form.services = [];
            this.itemsTotal = 0;
            this.updateTotalWithItems = true;
            if (this.settings) {
                this.form.fractional_min_amount = this.settings.fractional_min_amount || 10.00;
                this.form.reward_type = this.settings.reward_type || 'extension';
                this.form.reward_percentage = this.settings.reward_percentage || 1.00;
            }
        },

        // Adicione dentro de methods: {}
        openItemsModal(transaction, type) {
            this.selectedTransactionForView = transaction;
            this.viewingItemType = type;
            if (this.viewItemsModalInstance) {
                this.viewItemsModalInstance.show();
            }
        },
        formatCurrency(v) { return Number(v).toLocaleString('pt-BR', { minimumFractionDigits: 2 }); },
        formatDate(d) { return d ? new Date(d).toLocaleDateString('pt-BR', { timeZone: 'UTC' }) : '-'; },
        formatCurrencyInput(value) {
            if (value === '' || value === null || value === undefined) return '';
            return Number(value).toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
        },
        handleCurrencyInput(event, field) {
            let input = event.target;
            let value = input.value.replace(/\D/g, "");
            if (value === "") { this.form[field] = ''; input.value = ''; return; }
            let numericValue = (parseInt(value, 10) / 100);
            input.value = numericValue.toLocaleString('pt-BR', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
            this.form[field] = numericValue;
        },
        typeTransaction(type) {
            this.contactSearchResults = [];
            if (type === 'in') {
                this.form.transactionable_type = 'App\\Models\\Client';
            } else {
                this.form.transactionable_type = 'App\\Models\\Supplier';
            }
        },
        onContactInput() {
            this.showContactDropdown = true;

            clearTimeout(this.contactDebounce);
            if (this.contactSearchQuery.length < 2) return;
            this.contactDebounce = setTimeout(async () => {

                const endpoint = this.form.transactionable_type.includes('Client') ? '/clients' : '/suppliers';
                const res = await api.get(endpoint, { params: { search: this.contactSearchQuery, limit: 8 } });
                this.contactSearchResults = res.data.data || res.data;

            }, 300);
        },
        selectContact(contact) {
            this.form.transactionable_id = contact.id;
            this.contactSearchQuery = contact.name;
            this.showContactDropdown = false;
        },
        hideContactDropdown() { setTimeout(() => this.showContactDropdown = false, 200); },
        closeModal() {
            transactionModalState.close();
        },
        selectCategory(category) {
            this.form.category_id = category.id;
            this.categorySearchQuery = category.name;
            this.showCategoryDropdown = false;
        },
        hideCategoryDropdown() { setTimeout(() => this.showCategoryDropdown = false, 200); },
        selectCostCenter(costCenter) {
            this.form.cost_center_id = costCenter.id;
            this.costCenterSearchQuery = costCenter.code
                ? `[${costCenter.code}] ${costCenter.name}`
                : costCenter.name;

            this.showCostCenterDropdown = false;
        },

        hideCostCenterDropdown() {
            setTimeout(() => {
                this.showCostCenterDropdown = false;
                if (!this.form.cost_center_id) {
                    this.costCenterSearchQuery = '';
                }
            }, 150);
        },
        showAlert(message, type = 'success') {
            const id = Date.now();
            const themeClass = type === 'error' ? 'danger' : type;
            let icon = 'bi-check-circle-fill';
            if (themeClass === 'danger') icon = 'bi-x-circle-fill';
            if (type === 'warning') icon = 'bi-exclamation-triangle-fill';
            this.alerts.push({ id, message, type: themeClass, icon });
            setTimeout(() => this.removeAlert(id), themeClass === 'danger' ? 6000 : 4000);
        },
        removeAlert(id) { this.alerts = this.alerts.filter(a => a.id !== id); },
        async handleProductBranchChange(isInit = false) {
            if (!this.form.product_branch_id) return;

            // Se o usuário trocou a filial manualmente, limpa os produtos da linha para evitar inconsistência de estoque
            if (!isInit) {
                this.form.products.forEach(p => {
                    p.id = null;
                    p.searchQuery = '';
                    p.unit_price = 0;
                    p.stock = 0;
                });
                this.autoCalculateTotal();
            }

            this.globalLoading.show('Carregando produtos da filial...');
            try {
                const response = await api.get('/products', {
                    params: {
                        branch_id: this.form.product_branch_id,
                        no_paginate: true
                    }
                });

                this.availableProducts = response.data.data || response.data;
            } catch (error) {
                console.error("Erro ao carregar produtos da filial:", error);
                this.showAlert('Erro ao buscar o estoque de produtos.', 'error');
            } finally {
                this.globalLoading.hide();
            }
        },
        async handleServiceBranchChange(isInit = false) {
            if (!this.form.service_branch_id) return;

            // Se o usuário trocou a filial manualmente, limpa os campos da linha
            if (!isInit) {
                this.form.services.forEach(s => {
                    s.id = null;
                    s.searchQuery = '';
                    s.unit_price = 0;
                    s.stock = 0;
                });
                this.autoCalculateTotal();
            }

            this.globalLoading.show('Carregando serviços da filial...');
            try {
                // Chamada correta utilizando a rota principal de services com query parameter
                const response = await api.get('/services', {
                    params: {
                        branch_id: this.form.service_branch_id,
                        no_paginate: true
                    }
                });

                this.availableServices = response.data.data || response.data;
            } catch (error) {
                console.error("Erro ao carregar serviços da filial selecionada:", error);
                this.showAlert('Erro ao buscar o estoque de serviços.', 'error');
            } finally {
                this.globalLoading.hide();
            }
        },

    }
}
</script>
<style scoped>
.main-content {
    background-color: #f8fafc;
    min-height: 100vh;
    padding: 2rem;
    font-family: 'Inter', sans-serif;
}

.card {
    border-radius: 16px;
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.02);
}

.btn-pmg-primary {
    background: #561569;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 10px 20px;
    font-weight: 500;
}

.btn-pmg-light {
    background: #fff;
    border: 1px solid #e2e8f0;
    border-radius: 10px;
    color: #64748b;
    padding: 10px 20px;
}

.btn-pmg-danger {
    background: #fee2e2;
    color: #b91c1c;
    border: 1px solid #fecaca;
    border-radius: 10px;
    font-weight: 600;
}

.form-control-pmg {
    border-radius: 10px;
    border: 1px solid #e2e8f0;
    padding: 12px;
    transition: all 0.2s;
}

.form-control-pmg:focus {
    border-color: #561569;
    box-shadow: 0 0 0 4px rgba(33, 51, 97, 0.1);
}

.autocomplete-dropdown {
    max-height: 280px;
    overflow-y: auto;
    scrollbar-width: thin;
    z-index: 1100;
}

.autocomplete-item {
    transition: background 0.2s;
    cursor: pointer;
}

.autocomplete-item:hover {
    background-color: #f8fafc;
}

.bg-primary-subtle {
    background-color: #e0f2fe !important;
}

.text-primary {
    color: #0369a1 !important;
}

.table-pmg thead th {
    background: #f8fafc;
    color: #64748b;
    font-size: 0.75rem;
    text-transform: uppercase;
    padding: 1.2rem;
    border-bottom: 1px solid #edf2f7;
}

.table-pmg tbody td {
    padding: 1.2rem;
    border-bottom: 1px solid #f1f5f9;
}

.slide-fade-enter-active,
.slide-fade-leave-active {
    transition: all 0.4s;
}

.slide-fade-enter-from {
    transform: translateX(50px);
    opacity: 0;
}

.slide-fade-leave-to {
    opacity: 0;
    transform: scale(0.9);
}

.bg-danger-subtle {
    background-color: #fef2f2 !important;
    color: #dc2626 !important;
    border-left: 5px solid #dc2626 !important;
    animation: shake 0.4s ease-in-out;
}

.bg-success-subtle {
    border-left: 5px solid #16a34a !important;
}

.text-success-emphasis {
    color: #15803d !important;
}

.text-danger-emphasis {
    color: #b91c1c !important;
}

@keyframes shake {

    0%,
    100% {
        transform: translateX(0);
    }

    25% {
        transform: translateX(-5px);
    }

    75% {
        transform: translateX(5px);
    }
}

.dropdown-menu {
    z-index: 1065 !important;
}

.table-responsive {
    overflow: visible !important;
}

.dropdown-item {
    font-size: 0.9rem;
    color: #334155;
    transition: all 0.2s ease;
}

.dropdown-item:hover {
    background-color: #f8fafc;
    color: #1e293b;
}

.dropdown-item.text-danger:hover {
    background-color: #fff1f2 !important;
    color: #dc2626 !important;
}

.btn-pmg-icon.border {
    border-color: #e2e8f0 !important;
    background: white;
    width: 38px;
    height: 38px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    border-radius: 8px;
}

.btn-pmg-icon:hover {
    background-color: #f1f5f9;
}

.fade-enter-active,
.fade-leave-active {
    transition: opacity 0.3s ease;
}

.fade-enter-from,
.fade-leave-to {
    opacity: 0;
}

.cursor-pointer {
    cursor: pointer;
}

.border-dashed {
    border: 2px dashed #e2e8f0 !important;
}

.item-badge-hover {
    transition: all 0.2s ease;
}

.item-badge-hover:hover {
    transform: translateY(-2px);
    box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
    filter: brightness(0.95);
}

.text-purple {
    color: #8b5cf6 !important;
}

.required {
    color: #FF0000;
}
</style>